<script setup lang="ts">
import type { TabsListProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { TabsIndicator, TabsList } from 'reka-ui'
import { cn } from '@/ui/lib/utils'
import { tabsIndicatorVariants, tabsListVariants, type TabsVariants } from '.'

const props = withDefaults(
  defineProps<TabsListProps & { class?: HTMLAttributes['class']; variant?: TabsVariants['variant'] }>(),
  { variant: 'segmented' }
)

const delegatedProps = reactiveOmit(props, 'class', 'variant')
</script>

<template>
  <TabsList data-slot="tabs-list" v-bind="delegatedProps" :class="cn(tabsListVariants({ variant }), props.class)">
    <TabsIndicator
      aria-hidden="true"
      :class="tabsIndicatorVariants({ variant })"
      :style="{
        left: 'var(--reka-tabs-indicator-position)',
        width: 'var(--reka-tabs-indicator-size)'
      }"
    />
    <slot />
  </TabsList>
</template>
